import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod, selectStandard } from 'store/redux-store/placement-mods/selectors';
import { dataSorting, findKeyBaseOnValue, formatTypeAheadOptions } from '../../ModificationsUtils';

interface BillingTypeProps {
  readOnly?: boolean;
}

export const BillingType = ({ readOnly }: BillingTypeProps) => {
  const { control, getValues, setValue, clearErrors, setError, register } = useFormContext();
  const { t } = useTranslation();
  const billingType = 'billingType';
  register('billingTypeId');
  const bonusType: string = useWatch({ name: 'bonusType' });
  const isModEdit = useSelector(selectIsEditMod);
  const standard = useSelector(selectStandard);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const [isFieldReadonly, setFieldReadonly] = useState<boolean>(false);
  const [bonusBillingTypeOptions, setBonusBillingTypeOptions] = useState([]);

  const getBonusBillingTypeDropDown = async () => {
    const options = await getSearchFilterOptions('billingType');

    if (options?.length > 0) {
      const newOptions = formatTypeAheadOptions(options);
      setBonusBillingTypeOptions(newOptions);

      if (bonusType === 'Competitive') {
        setValue(billingType, 'None');
        setValue('billingTypeId', 1);
        setFieldReadonly(true);
        clearErrors(billingType);
      } else {
        setFieldReadonly(false);
        if (getValues(billingType)) {
          const selectedOption = findKeyBaseOnValue(bonusBillingTypeOptions, getValues(billingType));
          setValue('billingTypeId', selectedOption?.id);
          clearErrors(billingType);
        } else {
          setError(billingType, {});
        }
      }
    }
  };

  const getBillingTypeId = (value: string) => {
    const selectedOption = findKeyBaseOnValue(bonusBillingTypeOptions, value);
    return selectedOption?.id;
  };

  const handleChange = (value?: string) => {
    setValue(billingType, value);
    setValue('billingTypeId', getBillingTypeId(value));
    if (value) {
      clearErrors(billingType);
    }
  };

  useEffect(() => {
    getBonusBillingTypeDropDown();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFieldReadonly, bonusType]);

  const isFieldEditable = () => {
    if (readOnly !== undefined) {
      return readOnly;
    }
    if (standard) {
      return true;
    } else {
      if (isFieldReadonly) {
        return true;
      } else {
        return !isModEdit;
      }
    }
  };

  return (
    <Controller
      control={control}
      name={billingType}
      rules={{
        required: true,
      }}
      render={({field: { onChange, value, ...rest } }) => (
        <FormInputDropdown
          useMenuItem={true}
          name={billingType}
          label={`${t('placement.placementMods.billingType')}`}
          standard={true}
          options={dataSorting(bonusBillingTypeOptions) ?? []}
          handleChange={e => {
            handleChange(e.target.value);
            onChange(e.target.value);
          }}
          {...rest}
          inputValue={getValues(billingType) ?? ''}
          readOnly={isFieldEditable()}
          disabled={isSaveModApiCalling}
        ></FormInputDropdown>
      )}
    />
  );
};
